import { useTranslation } from '../../hooks/useTranslation';
import { shopThemes } from '../../config/shops';
import ShopHero, { Dice } from './ShopHero';
import ShopDetails, { ShopLink } from './ShopDetails';
import ShopGallery from './ShopGallery';
import ShopSeo from './ShopSeo';
import WidthWrapperEx from '../layout/WidthWrapperEx';

export default function ShopPage({ shop }) {
  const { t, locale } = useTranslation('shops');
  return <div lang={locale} style={shopThemes[shop.theme]} className="bg-[var(--shop-bg)] font-['Montserrat',sans-serif] text-[var(--shop-text)] selection:bg-[var(--shop-accent)] selection:text-[var(--shop-bg)]">
    <ShopSeo shop={shop} t={t} locale={locale} />
    <a href="#shop-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[10010] focus:rounded-lg focus:bg-white focus:p-4 focus:text-black">{t('nav.skip')}</a>
    <div id="shop-content" className="scroll-mt-[76px]">
      <ShopHero shop={shop} t={t} />
      <ShopDetails shop={shop} t={t} />
      <ShopGallery shop={shop} t={t} />
      <section className="relative overflow-hidden border-y border-[var(--shop-border)] bg-[var(--shop-panel)] py-12 text-[var(--shop-ink)]">
        <Dice className="pointer-events-none absolute -right-8 top-4 h-64 w-56 rotate-12 text-[var(--shop-ink)] opacity-20" />
        <WidthWrapperEx fullHeight={false} className="relative flex flex-col items-start justify-between gap-7 px-4 sm:px-6 lg:flex-row lg:items-center">
          <div className="max-w-xl"><h2 className="text-3xl font-black tracking-tight">{t('events.title')}</h2><p className="mt-3 text-sm leading-7">{t('events.text')}</p></div>
          <ShopLink href={`/calendar/${shop.slug}`} className="!bg-[var(--shop-button)] !text-white hover:!bg-[var(--shop-button-hover)]">{t('events.cta')}</ShopLink>
        </WidthWrapperEx>
      </section>
    </div>
  </div>;
}
